import React, { useCallback } from "react";
import { HalfCard } from "@swiggy-private/dls-web-core/dist/components/HalfCard";
import { FullWidthButton } from "@swiggy-private/dls-web-core/dist/components/FullWidthButton";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { CustomCloseIcon } from "@swiggy-private/core-ui";

import { BILL_IMAGE_REQUIRED } from "@payment-ui/constants";

import {
    Container,
    ImageWrapper,
    Heading,
    Description,
    ButtonWrapper,
    CloseIconContainer,
    TextButtonStyled,
    IMAGE_WIDTH,
    IMAGE_HEIGHT,
} from "./BillImageRequiredHalfCard.styles";
import { useTheme } from "styled-components";
import { B2C_METHOD_TEST_IDS } from "@swiggy-private/payment-test-ids";

interface BillImageRequiredHalfCardProps {
    onProceed: VoidFunction;
    onClose: VoidFunction;
    onDeny: VoidFunction;
}

const BillImageRequiredHalfCardContent = ({ onProceed, onDeny, onClose }: BillImageRequiredHalfCardProps) => {
    const theme = useTheme();
    const themeColors = theme.colors[theme.colorMode];

    return (
        <Container data-testid={B2C_METHOD_TEST_IDS.BILL_UPLOAD_HALF_CARD}>
            <CloseIconContainer>
                <CustomCloseIcon
                    onClick={onClose}
                    IconBgColor={themeColors.background_Button_Disabled}
                    IconFillColor={themeColors.text_Low_Emphasis}
                    size={28}
                    dataTestId={B2C_METHOD_TEST_IDS.BILL_UPLOAD_CLOSE}
                />
            </CloseIconContainer>
            <ImageWrapper>
                <Image
                    cloudinaryId={BILL_IMAGE_REQUIRED.HALF_CARD_ASSET}
                    alt={BILL_IMAGE_REQUIRED.HALF_CARD_ALT}
                    cloudinaryHeight={IMAGE_HEIGHT * 2}
                    cloudinaryWidth={IMAGE_WIDTH * 2}
                />
            </ImageWrapper>
            <Heading variant="V2.heading2.neutral.black" color="text_Highest_Emphasis">
                {BILL_IMAGE_REQUIRED.HEADING}
            </Heading>
            <Description variant="V2.body1.neutral.regular" color="text_Med_Emphasis">
                {BILL_IMAGE_REQUIRED.DESCRIPTION}
            </Description>
            <ButtonWrapper>
                <FullWidthButton
                    variant="primary"
                    onClick={onProceed}
                    data-testid={B2C_METHOD_TEST_IDS.BILL_UPLOAD_PROCEED}
                >
                    {BILL_IMAGE_REQUIRED.PROCEED_BTN}
                </FullWidthButton>
                <TextButtonStyled
                    color="primary"
                    buttonSize="medium"
                    onClick={onDeny}
                    data-testid={B2C_METHOD_TEST_IDS.BILL_UPLOAD_CANCEL}
                >
                    {BILL_IMAGE_REQUIRED.NO_THANKS_BTN}
                </TextButtonStyled>
            </ButtonWrapper>
        </Container>
    );
};

const BillImageRequiredHalfCard = ({ onProceed, onClose, onDeny }: BillImageRequiredHalfCardProps) => {
    const _onClose = useCallback((): void => {
        onClose && onClose();
    }, [onClose]);

    return (
        <HalfCard isOpen={true} onClose={_onClose} hideCloseIcon={true}>
            <BillImageRequiredHalfCardContent onProceed={onProceed} onClose={_onClose} onDeny={onDeny} />
        </HalfCard>
    );
};

export default React.memo(BillImageRequiredHalfCard);
